// Copyright 2019 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/** @module common-sk/modules/object
 *  @description Utility functions for dealing with Objects.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    deepCopy: function() {
        return deepCopy;
    },
    equals: function() {
        return equals;
    },
    getDelta: function() {
        return getDelta;
    },
    applyDelta: function() {
        return applyDelta;
    }
});
const _query = require("./query");
function deepCopy(o) {
    return JSON.parse(JSON.stringify(o));
}
function equals(a, b) {
    if (typeof a !== typeof b) {
        return false;
    }
    const ta = typeof a;
    if (ta === 'string' || ta === 'boolean' || ta === 'number') {
        return a === b;
    }
    if (ta === 'object') {
        if (Array.isArray(a)) {
            return JSON.stringify(a) === JSON.stringify(b);
        }
        return (0, _query.fromObject)(a) === (0, _query.fromObject)(b);
    }
    return false;
}
function getDelta(o, d) {
    const ret = {};
    Object.keys(o).forEach((key)=>{
        if (!equals(o[key], d[key])) {
            ret[key] = o[key];
        }
    });
    return ret;
}
function applyDelta(delta, o) {
    const ret = {};
    Object.keys(o).forEach((key)=>{
        // eslint-disable-next-line no-prototype-builtins
        if (delta.hasOwnProperty(key)) {
            ret[key] = deepCopy(delta[key]);
        } else {
            ret[key] = deepCopy(o[key]);
        }
    });
    return ret;
}
